import React from 'react';
import { Link } from 'react-router-dom';

const JoinNow = () => {
    return (
        <div>
            <div className='row'>
                <div className='col-lg-12 text-center mt-5'>
                    <p className="f-30 f-mon-reg text-white mb-0">What makes Prediction Dog The Big Dog on campus?</p>
                    <p className="f-50 f-mon-bold text-white lh-01 mt-1 txt-captl">JOIN NOW</p>
                    <div className="border-btm-pink-secondsec my-3"></div>
                    <p className="wdth-80-per text-white f-mon-light f-20 mt-3">
                        With my 36 years of extensive experience in sports betting, I have the skills to properly analyze
                        each game, each line, and each score to give a highly accurate result that will let you make it
                        BIG in the betting world.

                    </p>
                    <Link to="/packages" className="btn btn-light f-16 f-mon-reg btn-pink-now mb-5 mt-3 pad-btn-ho-fifth">JOIN NOW</Link>
                    <p className="wdth-80-per text-white f-mon-light f-20 mt-3">
                        As a sports forecaster, every analytics, history, and trend is carefully observed and evaluated to give you the WINNING EDGE and become famous sports bettors!
                    </p>
                </div>
                <div className='col-lg-12 text-center mt-cus-allwewant'>
                    <p className='f-43 f-mon-reg mb-0 text-white'>ALL WE WANT IS TO COVER YOUR BET</p>
                    <p className='f-66 f-mon-bold clr-e0 lh-01 txt-captl'>Get Complimentary Offer</p>
                    <div className="border-btm-white-secondsec my-3"></div>
                    <p className="wdth-80-per text-white f-mon-light f-20 mt-4 mb-3">If you’re a first-time visitor, then you get the “Play of the Day” offer where you get ONE free sports betting advice or prediction on any upcoming game from our sports forecaster.
                        So Click here and WIN.
                    </p>
                    {/* <p className="wdth-80-per text-white f-mon-light f-20 mt-4 mb-3">
                        Getting sports betting tips online may seem like a farfetched scheme but when you get the taste of becoming a winner with our first free sport betting predicting advice you will realize that this is not a scam but the real deal!
                    </p> */}
                    <Link to="/tips" className="btn btn-light f-16 f-mon-reg btn-pink-now mb-3 mt-4">GET BETTING TIPS</Link>
                </div>
            </div>
        </div>
    )
}

export default JoinNow;